import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, Box, Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { Refresh, Search, Videocam } from "@mui/icons-material";

function HeaderCamaras({
  comercios,
  camarasDelComercio,
  comercioSeleccionado,
  camaraSeleccionada,
  filtros,
  loading,
  checkingStatus,
  onRefresh,
  onConsultar,
  onSeleccionarComercio,
  onSeleccionarCamara,
  onFiltroChange,
  onClearFilters,
}) {
  return (
    <Box
      sx={{ bgcolor: "white", border: "1px solid #dce4ed", borderRadius: 3, overflow: "hidden" }}
    >
      <Box
        sx={{
          bgcolor: "#193d50",
          color: "#fff",
          p: 2.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Videocam />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700 }}>
            Cámaras
          </Typography>
          <Typography variant="body2" sx={{ color: "#d6e5ee" }}>
            Disponibilidad reportada y consulta del equipo por comercio
          </Typography>
        </Box>
        <Button
          onClick={onRefresh}
          disabled={loading}
          startIcon={<Refresh />}
          sx={{ "&&": { color: "#fff" }, border: "1px solid #8aa5b7" }}
        >
          Actualizar
        </Button>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          p: 2.5,
          "& .MuiInputBase-root": { minHeight: 52, fontSize: 14, color: "#203d52" },
          "& .MuiInputLabel-root": { color: "#50677d" },
        }}
      >
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={comercios}
            value={comercioSeleccionado}
            onChange={(_, value) => onSeleccionarComercio(value)}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(a, b) => a.name === b.name}
            renderInput={(params) => (
              <TextField {...params} label="Comercio" placeholder="Todos los comercios" />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={camarasDelComercio}
            value={camaraSeleccionada}
            disabled={!comercioSeleccionado}
            onChange={(_, value) => onSeleccionarCamara(value)}
            getOptionLabel={(option) => `${option.name} · ${option.ip || "Sin IP"}`}
            isOptionEqualToValue={(a, b) => a.hostid === b.hostid}
            renderInput={(params) => <TextField {...params} label="Cámara" />}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            fullWidth
            label="Buscar cámara, comercio o IP"
            value={filtros.busqueda}
            onChange={(e) => onFiltroChange("busqueda", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            select
            fullWidth
            label="Disponibilidad reportada"
            value={filtros.estado}
            onChange={(e) => onFiltroChange("estado", e.target.value)}
          >
            <MenuItem value="todos">Todas</MenuItem>
            <MenuItem value="disponibles">Con alcance</MenuItem>
            <MenuItem value="sinAlcance">Sin alcance</MenuItem>
            <MenuItem value="desconocidos">Sin verificar</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="contained"
            startIcon={<Search />}
            disabled={!camaraSeleccionada?.ip || checkingStatus || loading}
            onClick={() => onConsultar(camaraSeleccionada.ip)}
            sx={{
              "&&": { bgcolor: "#245e89", color: "#fff" },
              "&&.Mui-disabled": { bgcolor: "#e3e9ef", color: "#63768a" },
            }}
          >
            Consultar
          </Button>
          <Button onClick={onClearFilters} sx={{ "&&": { color: "#365b79" } }}>
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
HeaderCamaras.propTypes = {
  comercios: PropTypes.array.isRequired,
  camarasDelComercio: PropTypes.array.isRequired,
  comercioSeleccionado: PropTypes.object,
  camaraSeleccionada: PropTypes.object,
  filtros: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  checkingStatus: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired,
  onConsultar: PropTypes.func.isRequired,
  onSeleccionarComercio: PropTypes.func.isRequired,
  onSeleccionarCamara: PropTypes.func.isRequired,
  onFiltroChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};
export default HeaderCamaras;
